define(['text!./templates/question-set.html'],
    (templateStr)=> {
        return ()=> {
            return {
                restrict: 'A',
                template: templateStr,
                scope: {
                    'gwPlQuestionSet': '='
                },
                controller: ['$scope', 'QuestionSetService', ($scope, QuestionSetService)=> {
                    $scope.questionSets = QuestionSetService.getQuestionSetViewModel($scope.gwPlQuestionSet);
                   // console.log("questionSets ",$scope.questionSets )
                }]
            };
        };
    }
);


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/questionsets/QuestionSetDirective.js
 **/